module.exports = __webpack_public_path__ + "static/media/user0.06cae3a1.jpg";